import React, { useContext } from "react";
import CartContext from "../../context/CartContext";
import { Box, Typography, Paper } from "@mui/material";
import CardProductItem from "../product/CardProductItem";

const CartItem = () => {
  const cartCtx = useContext(CartContext);
  return (
    <Paper
      elevation={0}
      sx={{
        p: 0,
        mb: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        {cartCtx.items.map((item) => (
          <CardProductItem key={item.id} product={item} />
        ))}
      </Box>
    </Paper >
  );
};

export default CartItem;